import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import React from 'react';
import styled, { css } from '@xstyled/styled-components';
import { breakpoints } from '@xstyled/system';
import { Box } from '@trybeapp/ui.box';
import { filterComponent } from '@trybeapp/ui.system';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var _excluded = ["width", "children"],
  _excluded2 = ["children"];
var Col = function Col(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? true : _ref$width,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    col: width,
    px: 2
  }, props), children);
};
var Row = function Row(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Box, _extends({
    row: true,
    mx: -2
  }, props), children);
};
var responsiveSizes = /*#__PURE__*/breakpoints({
  sm: /*#__PURE__*/css(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    max-width: 540px;\n  "]))),
  md: /*#__PURE__*/css(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    max-width: 720px;\n  "]))),
  lg: /*#__PURE__*/css(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    max-width: 960px;\n  "]))),
  xl: /*#__PURE__*/css(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    max-width: 1140px;\n  "])))
});
var Container = /*#__PURE__*/styled(filterComponent(Box, ['fluid']))(function (_ref3) {
  var fluid = _ref3.fluid;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      width: 100%;\n      padding-right: 2;\n      padding-left: 2;\n      margin-right: auto;\n      margin-left: auto;\n      ", "\n    "])), !fluid && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n        ", "\n      "])), responsiveSizes));
});

export { Col, Container, Row };
